"use strict";

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _reactDropzone = require("react-dropzone");

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    default: a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

function _slicedToArray(a, b) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, b) || _unsupportedIterableToArray(a, b) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(a, b) {
  if (a) {
    if ("string" == typeof a) return _arrayLikeToArray(a, b);
    var c = Object.prototype.toString.call(a).slice(8, -1);
    return "Object" === c && a.constructor && (c = a.constructor.name), "Map" === c || "Set" === c ? Array.from(a) : "Arguments" === c || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray(a, b) : void 0;
  }
}

function _arrayLikeToArray(a, b) {
  (null == b || b > a.length) && (b = a.length);

  for (var c = 0, d = Array(b); c < b; c++) {
    d[c] = a[c];
  }

  return d;
}

function _iterableToArrayLimit(a, b) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(a)) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        d || null == h["return"] || h["return"]();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }
}

function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}

function _objectWithoutProperties(a, b) {
  if (null == a) return {};

  var c,
      d,
      e = _objectWithoutPropertiesLoose(a, b);

  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(a);

    for (d = 0; d < f.length; d++) {
      c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
    }
  }

  return e;
}

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

function Accept(a) {
  var b = a.dropzoneText,
      c = _objectWithoutProperties(a, ["dropzoneText"]),
      d = c.field,
      e = (d || []).defaultValue,
      f = (0, _react.useState)(e ? [e] : []),
      g = _slicedToArray(f, 2),
      h = g[0],
      i = g[1],
      j = (0, _react.useState)("dropzone"),
      k = _slicedToArray(j, 2),
      l = k[0],
      m = k[1],
      n = (0, _reactDropzone.useDropzone)({
    accept: "image/*",
    onDrop: function onDrop(a) {
      var b = c.id,
          d = c.formID,
          e = c.field,
          f = c.isRequired,
          g = c.updateForm,
          h = c.setTouched,
          j = c.unsetError;
      i(a.map(function (a) {
        return Object.assign(a, {
          preview: URL.createObjectURL(a)
        });
      })), g(a, e), h(b), j(b);
    },
    onDragOver: function onDragOver() {
      m("dropzone over");
    },
    onDragLeave: function onDragLeave() {
      m("dropzone");
    },
    onDropAccepted: function onDropAccepted() {
      m("dropzone");
    }
  }),
      o = n.getRootProps,
      p = n.getInputProps,
      q = n.isDragActive,
      r = n.isDragAccept,
      s = n.isDragReject,
      t = h && 0 < !!h.length && h.map(function (a) {
    return _react["default"].createElement("div", {
      key: a.name
    }, _react["default"].createElement("div", null, _react["default"].createElement("img", {
      src: a.preview
    })));
  }),
      u = c.id,
      v = c.formID,
      w = c.isRequired;

  (0, _react.useEffect)(function () {
    return function () {
      h.forEach(function (a) {
        return URL.revokeObjectURL(a.preview);
      });
    };
  }, [h]);
  return _react["default"].createElement("div", {
    className: "container"
  }, _react["default"].createElement("div", o({
    className: l
  }), _react["default"].createElement("input", _extends({
    id: "input_".concat(v, "_").concat(u),
    name: "input_".concat(u),
    type: "file",
    required: w
  }, p())), t && _react["default"].createElement("div", {
    className: "preview"
  }, t), _react["default"].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: b || "Drag 'n' drop some files here, or click to select files"
    }
  })));
}

var _default = Accept;
exports["default"] = _default;